/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import { SeoService } from './@core/utils/seo.service';
import { InitUserService } from './@theme/services/init-user.service';

@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {

  constructor(
    private analytics: AnalyticsService, 
    private seoService: SeoService,
    private initUserService: InitUserService,
  ) {
  }

  ngOnInit(): void {
    this.analytics.identifyUsers();
    this.seoService.trackCanonicalChanges();

    this.initUserService.initCurrentUser().subscribe();
    
  }
}
